import css from 'styled-jsx/css';

const styles = css`.liability-field-set{padding:.5rem 0}.liability-field-set .debt-count{display:flex;justify-content:space-between;align-items:center}.liability-field-set .delete-icon{max-height:94px;margin-bottom:.5rem}`;

export default styles;